// AUTH actions
const auth_types = {

  VALIDATE_TOKEN: {
    request: "VALIDATE_TOKEN_REQUEST",
    success: "VALIDATE_TOKEN_SUCCESS",
    failure: "VALIDATE_TOKEN_FAILURE"
  },

  LOGIN: {
    request: "LOGIN_REQUEST",
    success: "LOGIN_SUCCESS",
    failure: "LOGIN_FAILURE"
  },

  LOGOUT: {
    request: "LOGOUT_REQUEST",
    success: "LOGOUT_SUCCESS",
    failure: "LOGOUT_FAILURE",
    force: "FORCE_LOGOUT"
  }

}

export default auth_types



// WEBPACK FOOTER //
// ./src/js/constants/authTypes.js